import classNames from "classnames";
import styles from "./AscActivityChartCard.module.scss";
import AscGenericCard from "../AscGenericCard/AscGenericCard";
import { ChevronLeftIcon, ChevronRightIcon } from "../../AscIcons";
import AscButton from "../../AscButton/AscButton";
import AscDropdown from "../../AscDropdown/AscDropdown";
import AscChart from "../../AscChart/AscChart";
export interface AscActivityChartCardProps {
  className?: string;
  dataArr: string[] | number[];
  labels: string[];
  title: string;
  chartClassName?: string;
  loading?: boolean;
}

export default function AscActivityChartCard({
  className,
  dataArr,
  labels,
  title,
  chartClassName,
  loading = false
}: AscActivityChartCardProps) {
  return (
    <AscGenericCard
      loading={loading}
      title={<Header title={title} />}
      coverImageUrl={null}
      data-testid="asc-activity-chart-card"
      className={classNames(styles.ground, className)}
    >
      <AscChart className={chartClassName} dataArr={dataArr} labels={labels} />
    </AscGenericCard>
  );
}

function Header({ title }: { title: string }) {
  return (
    <div className={styles.header}>
      <h5>{title}</h5>
      <div className={styles.headerNav}>
        <div className={styles.navButtons}>
          <AscButton
            variant="lightGray"
            squarishIcon
            icon={<ChevronLeftIcon />}
          />
          <AscButton
            variant="lightGray"
            squarishIcon
            icon={<ChevronRightIcon />}
          />
        </div>
        <AscDropdown title="Skills">
          <AscDropdown.Option>Option 1</AscDropdown.Option>
          <AscDropdown.Option>Option 2</AscDropdown.Option>
          <AscDropdown.Option>Option 3</AscDropdown.Option>
          <AscDropdown.Option>Option 4</AscDropdown.Option>
        </AscDropdown>
      </div>
    </div>
  );
}
